export default __webpack_public_path__ + "static/media/PressStart2P.328fa1f6.woff";